import clsx from "clsx";
import Link from "next/link";
import React from "react";

const Paginate = ({
  pageCount = 1,
  activePage = 1,
  baseUri = "/",
  marginPagesDisplayed = 1,
  pageRangeDisplayed = 1,
}) => {
  const currentPage = parseInt(String(activePage), 10) || 1;
  const totalPages = parseInt(String(pageCount), 10) || 1;

  const createPages = () => {
    const pages = [];

    const startPage = Math.max(currentPage - pageRangeDisplayed, 1);
    const endPage = Math.min(currentPage + pageRangeDisplayed, totalPages);

    if (startPage !== 1) {
      for (let i = 1; i <= marginPagesDisplayed; i++) {
        pages.push(renderPageLink(i));
      }
      pages.push(<span key="start-ellipsis">...</span>);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(renderPageLink(i));
    }

    if (endPage !== totalPages) {
      pages.push(<span key="end-ellipsis">...</span>);
      for (
        let i = totalPages - marginPagesDisplayed + 1;
        i <= totalPages;
        i++
      ) {
        pages.push(renderPageLink(i));
      }
    }

    return pages;
  };

  const renderPageLink = (page) => (
    <Link
      key={page}
      href={page === 1 ? baseUri : `${baseUri}/page/${page}`}
      passHref
      className={clsx(
        "w-component h-component flex items-center justify-center rounded-full bg-white text-center font-body text-sm transition-colors hover:bg-zinc-800 hover:text-white",
        {
          "!bg-zinc-800 text-white": page === currentPage,
        }
      )}>

      {page}

    </Link>
  );

  return (
    (<div
      className={clsx(
        "Paginate",
        "flex items-center justify-center space-x-2 py-16 font-body text-sm lg:space-x-4"
      )}
    >
      <Link
        href={currentPage > 1 ? `${baseUri}/page/${currentPage - 1}` : baseUri}
        passHref
        className="block px-4 hover:opacity-75 lg:px-8"
        rel="prev">
        
          Prev
        
      </Link>
      {createPages()}
      <Link
        href={
          currentPage < totalPages
            ? `${baseUri}/page/${currentPage + 1}`
            : `${baseUri}/page/${totalPages}`
        }
        passHref
        className="block px-4 hover:opacity-75 lg:px-8"
        rel="next">
        
          Next
        
      </Link>
    </div>)
  );
};

export default Paginate;
